import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-form-section"
export default class extends Controller {
  static targets = ['dateBody', 'dateHeader', 
                    'extrasBody', 'extrasHeader',
                    'floorplansBody', 'floorplansHeader',
                    'formSection', 'eventTypeBody', 
                    'eventTypeHeader']

  connect() {
    this.formSectionTarget.value = 'event_type';
  }

  // OPEN FUNCTIONS

  open(target){
    target.classList.add('open');
    target.classList.remove('closed');
  }

  openDate(){
    this.open(this.dateBodyTarget);
    this.close(this.dateHeaderTarget);
  }

  openFloorplans(){
    this.formSectionTarget.value = 'floorplans';
    this.closeDate();
    this.open(this.floorplansBodyTarget);
    this.close(this.floorplansHeaderTarget);
  }

  // CLOSE FUNCTIONS

  close(target){
    target.classList.add('closed');
    target.classList.remove('open');
  }

  closeEventType(){
    this.close(this.eventTypeBodyTarget);
    this.open(this.eventTypeHeaderTarget);
  }

  closeDate(){
    this.close(this.dateBodyTarget);
    this.open(this.dateHeaderTarget);
  }

  closeFloorplans(){
    this.close(this.floorplansBodyTarget);
    this.open(this.floorplansHeaderTarget);
  }

  // CONFIRM FUNCTIONS

  confirmEventType(){
    if(this.formSectionTarget.value === 'event_type') {
      this.formSectionTarget.value = 'date';
    }
    this.closeEventType();
    this.openDate();
  }

  confirmDate(){
    if(this.formSectionTarget.value === 'date') {
      this.formSectionTarget.value = 'floorplans';
    }
    this.closeDate();
    this.openFloorplans();
  }  

  confirmFloorplans(){
    if(this.formSectionTarget.value = 'floorplans') {
      this.formSectionTarget.value = 'extras';
    }
    this.closeFloorplans();
    this.open(this.extrasBodyTarget);
    this.close(this.extrasHeaderTarget);
  }

  confirmExtras(){
    if(this.formSectionTarget.value === 'extras') {
      this.formSectionTarget.value = '';
    }
    this.close(this.extrasBodyTarget);
    this.open(this.extrasHeaderTarget);
  }

  keepExtras(){
    this.formSectionTarget.value = 'extras';
  }
}
